var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.179,
    height: 22.179,
    viewBox: "0 0 22.179 22.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.551 21.826) rotate(-135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.869,12.991l-.573.573a2.689,2.689,0,0,1-3.8,0h0L3.166,6.237a1.9,1.9,0,0,1,0-2.689l.382-.382a1.966,1.966,0,0,1,2.689,0l5.41,5.41a.326.326,0,0,1-.453.469l-.008-.008-5.41-5.41a1.292,1.292,0,0,0-1.766,0l-.382.382a1.249,1.249,0,0,0,0,1.766h0L10.955,13.1a2.088,2.088,0,0,0,2.88,0l.573-.573a2.037,2.037,0,0,0,0-2.88L6.237,1.479a2.824,2.824,0,0,0-3.993,0l-.765.764a2.824,2.824,0,0,0,0,3.993L7.733,12.49a.326.326,0,0,1-.453.469l-.008-.008L1.018,6.7a3.476,3.476,0,0,1,0-4.916h0l.765-.765a3.476,3.476,0,0,1,4.916,0h0L14.87,9.189a2.688,2.688,0,0,1,0,3.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.24,0A3.458,3.458,0,0,0,1.782,1.018l-.764.764a3.476,3.476,0,0,0,0,4.916h0l6.254,6.254a.326.326,0,0,0,.469-.453l-.008-.008L1.479,6.238a2.824,2.824,0,0,1,0-3.993l.765-.765a2.824,2.824,0,0,1,3.993,0l8.171,8.171a2.037,2.037,0,0,1,0,2.88l-.573.573a2.088,2.088,0,0,1-2.88,0L3.628,5.776a1.249,1.249,0,0,1,0-1.766h0l.382-.382a1.292,1.292,0,0,1,1.766,0l5.41,5.41a.326.326,0,0,0,.469-.453l-.008-.008-5.41-5.41a1.966,1.966,0,0,0-2.689,0l-.382.382a1.9,1.9,0,0,0,0,2.689l7.328,7.328a2.689,2.689,0,0,0,3.8,0h0l.573-.573a2.689,2.689,0,0,0,0-3.8h0L6.7,1.018A3.458,3.458,0,0,0,4.24,0Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.79ea28b14335edfaebd2029842d3fef0.svg";
export { ForwardRef as ReactComponent };